
export const NotFound = () => (
    <div>
        <h3>Page Not Found</h3>
    </div>
)